import api, { createCustomApi } from "./api";

export const USER_KEY = 'tispot_user';

export const checkEmailExists = async (email) => {
    try {
        const response = await api.get(`/users?filters[$and][0][email][$eq]=${email}`);

        if (response?.data?.length > 0) {
            return true;
        }
        return false;
    } catch (e) {
        console.error('Error checking user existence:', e);
        throw e;
    }
};

export const checkUsernameExists = async (username) => {
    try {
        const response = await api.get(`/users?filters[$and][0][username][$eq]=${username}`);

        if (response?.data?.length > 0) {
            return true;
        }
        return false;
    } catch (e) {
        console.error('Error checking user existence:', e);
        throw e;
    }
};

export const createUser = async (data) => {
    try {
        // Check if user exists first
        const userExistsEmail = await checkEmailExists(data.email);
        if (userExistsEmail) {
            return { exists: true, data: 'email' };
        }
        const userExistsUsername = await checkUsernameExists(data.username);
        if (userExistsUsername) {
            return { exists: true, data: 'username' };
        }

        // Create user
        const response = await api.post('/auth/local/register', data);

        if (!response.data || !response.data.user) {
            throw new Error('User creation failed');
        }

        // loginUser(response.data);

        return response.data;
    } catch (e) {
        console.error('Error in user creation:', e);
        return false;
    }
};

export const credentialCheck = async (data) => {
    try {
        const response = await api.post('/auth/local', data);
        // console.log(response.data);
        return response.data;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const updateUser = async (userId, data) => {
    try {
        const response = await api.put(`/users/${userId}`, data);
        if (response.data) {
            // Get current data from localStorage
            const userData = JSON.parse(localStorage.getItem(USER_KEY));
            // Update the user data while preserving other properties like jwt
            userData.user = { ...userData.user, ...data };
            // Save back to localStorage
            localStorage.setItem(USER_KEY, JSON.stringify(userData));
            return response.data;
        }
        return false;
    } catch (e) {
        console.error('Error in user update:', e);
        return false;
    }
};

export const changePassword = async (data) => {
    try {
        const userData = localStorage.getItem(USER_KEY);
        const { jwt } = JSON.parse(userData);

        const customApi = createCustomApi(jwt);
        await customApi.post('/auth/change-password', data);

        // console.log(response);
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const loginUser = async (data) => {
    localStorage.setItem(USER_KEY, JSON.stringify(data));
};

export const checkLoggedIn = async () => {
    try {
        const userData = localStorage.getItem(USER_KEY);
        if (!userData) {
            return false;
        }

        const { jwt } = JSON.parse(userData);
        if (!jwt) {
            localStorage.removeItem(USER_KEY);
            return false;
        }

        // Test the token against Strapi's API
        const customApi = createCustomApi(jwt);
        await customApi.get('/users/me');
        return true;

    } catch (error) {
        // If the request fails, the token is invalid/expired
        localStorage.removeItem(USER_KEY);
        return false;
    }
};

export const getCurrentUserData = async () => {
    try {
        if (await checkLoggedIn()) {
            const userData = localStorage.getItem(USER_KEY);
            const { jwt } = JSON.parse(userData);
            const customApi = createCustomApi(jwt);
            const data = await customApi.get('/users/me?populate=*', jwt);
            return data.data;
        } else {
            return false;
        }
    } catch (e) {
        console.error('Error fetching user data: ', e);
    }
};

export const logout = async () => {
    try {
        localStorage.removeItem(USER_KEY);
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const uploadProfilePicture = async (file) => {
    try {
        // console.log(file);
        const formData = new FormData();
        formData.append('files', file);

        const uploadResponse = await api.post('/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (!uploadResponse.data || uploadResponse.data.length === 0) {
            throw new Error('File upload failed');
        }

        return uploadResponse.data[0];
    } catch (error) {
        console.error('Error uploading profile picture:', error);
        throw error;
    }
};

export const updateProfilePicture = async (userId, fileId) => {
    try {
        const response = await api.put(`/users/${userId}`, {
            profilePicture: fileId
        });

        return response.data;
    } catch (error) {
        console.error('Error updating profile picture:', error);
        throw error;
    }
};

export const softDeleteUser = async (userId) => {
    try {
        const response = await api.post(`/soft-delete-user/${userId}`);

        if (response.data) {
            // await logout(); // Log out the user after soft delete
            return true;
        }
        return false;
    } catch (e) {
        console.error('Error in soft deleting user:', e);
        return false;
    }
};

export const forgotPassword = async (email) => {
    try {
        const response = await api.post('/auth/forgot-password', {
            email: email
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error in forgot password:', error);
        if (error.response?.data?.error?.message) {
            throw new Error(error.response.data.error.message);
        }
        throw new Error('Une erreur est survenue. Veuillez réessayer plus tard.');
    }
};

export const resetPassword = async (code, password, passwordConfirmation) => {
    try {
        const response = await api.post('/auth/reset-password', {
            code,
            password,
            passwordConfirmation,
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error in reset password:', error);
        if (error.response?.data?.error?.message) {
            throw new Error(error.response.data.error.message);
        }
        throw new Error('Une erreur est survenue. Veuillez réessayer plus tard.');
    }
};